import React from 'react';
import { Button, Form } from 'antd';
import { useTranslations } from 'next-intl';
import { PatternFormat } from 'react-number-format';

import { useAppDispatch } from 'store';

import { useSendSms } from '../hooks';
import { setPhone } from '../store';

// import { useSendSms } from 'modules/auth';

const LoginStep: React.FC = () => {
  const t = useTranslations('auth');
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();

  const { mutate, isLoading } = useSendSms();

  const onFinish = (values: { phone: string }) => {
    const phone = values.phone.replace(/\s|-/g, '');
    const isPhoneValid = phone?.length === 13;

    if (isPhoneValid) {
      mutate(phone);
      dispatch(setPhone(phone));
    } else {
      form.setFields([
        {
          name: 'phone',
          errors: [t('phone_invalid')]
        }
      ]);
    }
  };

  return (
    <div className="flex h-1/2 w-full items-center justify-center sm:h-full">
      <div className="item-center max-w-100 flex flex-col justify-center">
        <h2 className="mb-2 text-3xl font-semibold">{t('kirish')}</h2>
        <p className="mb-4 text-sm text-gray-800">{t('kirish_desc')}</p>

        <Form form={form} onFinish={onFinish} layout="vertical">
          <Form.Item
            name="phone"
            rules={[
              {
                required: true,
                message: t('phone_validation_message')
              }
            ]}
          >
            <PatternFormat
              format="+998 ## ### ## ##"
              mask=" "
              allowEmptyFormatting
              placeholder={t('phone_placeholder')}
              className="!h-13 w-full !rounded-xl !border !border-transparent !bg-gray-100 !p-3 hover:!border-green-500 hover:!outline-green-500 focus:!outline-green-500"
            />
          </Form.Item>

          <Button
            htmlType="submit"
            loading={isLoading}
            className="!py-5.5 !w-full !rounded-md !border-none !bg-green-500 !text-base !text-white"
          >
            {t('kirish')}
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default LoginStep;
